[
  {
    "id": 1,
    "name": "G-G Wood Fabric: Головний офіс",
    "type": "Офіс",
    "address": "Київ, просп. Берестейський, 53",
    "position": [50.45642678147621, 30.432492498304764],
    "rating": 4.8,
    "operational_index": 95
  },
  {
    "id": 2,
    "name": "Центральний шоурум",
    "type": "Магазин",
    "address": "Київ, Кільцева дорога, 110",
    "position": [50.38183617773184, 30.44098186335717],
    "rating": 4.4,
    "operational_index": 88
  },
  {
    "id": 3,
    "name": "Західноукраїнська філія",
    "type": "Офіс",
    "address": "Львів, вул. Кам'янецька, 3",
    "position": [49.81167365396289, 24.03863245915537],
    "rating": 3.7,
    "operational_index": 64
  },
  {
    "id": 4,
    "name": "Виробничий цех №1",
    "type": "Виробництво",
    "address": "Житомир, вул. Кооперативна, 6",
    "position": [50.2684290388991, 28.715608704096514],
    "rating": 4.3,
    "operational_index": 70
  },
  {
    "id": 5,
    "name": "Склад пиломатеріалів",
    "type": "Склад",
    "address": "Рівне, вул. Будівельників, 4",
    "position": [50.644334865757, 26.268153923645933],
    "rating": 3.9,
    "operational_index": 65
  },
  {
    "id": 6,
    "name": "Південний магазин меблів",
    "type": "Магазин",
    "address": "Одеса, вул. Олександра Свіща, 59а",
    "position": [46.47493097259873, 30.70943531458092],
    "rating": 4.6,
    "operational_index": 80
  },
  {
    "id": 7,
    "name": "Харківський логістичний центр",
    "type": "Склад",
    "address": "Харків, провул. Залютино",
    "position": [49.97664567694314, 36.151310996246195],
    "rating": 4.1,
    "operational_index": 75
  },
  {
    "id": 8,
    "name": "Дніпровський шоурум",
    "type": "Магазин",
    "address": "Дніпро, просп. Слобожанський, 37",
    "position": [48.50129180957536, 35.07054464102209],
    "rating": 4.4,
    "operational_index": 78
  },
  {
    "id": 9,
    "name": "Цех обробки деревини",
    "type": "Виробництво",
    "address": "Івано-Франківськ, провул. Хлиплин",
    "position": [48.88942162966416, 24.757739548183594],
    "rating": 4.2,
    "operational_index": 60
  },
  {
    "id": 10,
    "name": "Вінницький філіал",
    "type": "Магазин",
    "address": "Вінниця, просп. Космонавтів, 40",
    "position": [49.22428939533982, 28.41941782417531],
    "rating": 4.7,
    "operational_index": 72
  },
  {
    "id": 11,
    "name": "Склад фурнітури",
    "type": "Склад",
    "address": "Хмельницький, вул. Сільськогосподарська, 15",
    "position": [49.43440185549405, 27.02345883123428],
    "rating": 3.8,
    "operational_index": 55
  },
  {
    "id": 12,
    "name": "Магазин 'Еко-Меблі'",
    "type": "Магазин",
    "address": "Черкаси, вул. Якубовського, 10",
    "position": [49.43849653095044, 32.011051278322704],
    "rating": 4.5,
    "operational_index": 68
  },
  {
    "id": 13,
    "name": "Чернігівська майстерня",
    "type": "Виробництво",
    "address": "Чернігів, вул. Гребінки, 128",
    "position": [51.51011744633851, 31.248957089030483],
    "rating": 4.0,
    "operational_index": 58
  },
  {
    "id": 14,
    "name": "Полтавський регіональний офіс",
    "type": "Офіс",
    "address": "Полтава, вул. Решетилівська, 32а",
    "position": [49.60067064553893, 34.513723110460994],
    "rating": 4.6,
    "operational_index": 64
  },
  {
    "id": 15,
    "name": "Склад готової продукції",
    "type": "Склад",
    "address": "Луцьк, вул. Залізнична 5",
    "position": [50.75657847940109, 25.329987528748614],
    "rating": 3.7,
    "operational_index": 50
  },
  {
    "id": 16,
    "name": "Тернопільський шоурум",
    "type": "Магазин",
    "address": "Тернопіль, вул. Чумацька, 1",
    "position": [49.55326362125294, 25.570263116717925],
    "rating": 4.3,
    "operational_index": 62
  },
  {
    "id": 17,
    "name": "Ужгородська точка видачі",
    "type": "Магазин",
    "address": "Ужгород, вул. Легоцького, 80",
    "position": [48.60737639023343, 22.267840492630388],
    "rating": 4.8,
    "operational_index": 59
  },
  {
    "id": 18,
    "name": "Чернівецький меблевий хаб",
    "type": "Магазин",
    "address": "Чернівці, вул. Хотинська, 41м",
    "position": [48.32134406754136, 25.945019748408313],
    "rating": 4.2,
    "operational_index": 66
  },
  {
    "id": 19,
    "name": "Кропивницький склад",
    "type": "Склад",
    "address": "Кропивницький, пров. Новосельский",
    "position": [48.507651473275075, 32.264834816098194],
    "rating": 3.5,
    "operational_index": 48
  },
  {
    "id": 20,
    "name": "Миколаївський магазин",
    "type": "Магазин",
    "address": "Миколаїв, Херсонське шосе, 1",
    "position": [46.96067606768178, 32.0397863230595],
    "rating": 4.2,
    "operational_index": 52
  }
]
